'use client';

import { useContext } from 'react';
import { useTranslation } from 'next-i18next';
import { MapIcon } from '@heroicons/react/24/outline';
import { Button } from '@components/common';
import { HeaderSearchContext } from '@components/contexts/HeaderSearchContext';

const googleAPIKey = process.env.GOOGLE_MAPS_CLIENT_API_KEY as string;

interface MapButtonProps {
  locale: Locale;
}

export const MapButton = ({ locale }: MapButtonProps) => {
  const { t } = useTranslation('common');
  const headerSearch = useContext(HeaderSearchContext);

  if (!googleAPIKey) return null;

  const handleOpenMap = () => {
    void (async () => {
      const { showJobsMapModal } = await import('@components/templates/job/list/JobsMapModal');
      showJobsMapModal({
        googleApiKey: googleAPIKey,
        locale,
        queryParams: headerSearch?.queryParams,
      });
    })();
  };

  return (
    <Button
      styling="soft"
      rounding="normal"
      color="ink-medium"
      onClick={handleOpenMap}
      size="xs"
      aria-label={t('add.job.open.map')}
      title={t('add.job.open.map')}
    >
      <MapIcon className="size-6" />
    </Button>
  );
};
